export default __webpack_public_path__ + "b84ffd1.png";